import { withErrorBoundary } from '@sentry/react'
import { createFileRoute } from '@tanstack/react-router'

import { AssignmentDetailsPage } from '@/pages/assignments/AssignmentDetailsPage.tsx'
import { SentryErrorPage } from '@/pages/error/SentryErrorPage'

export const Route = createFileRoute('/assignments/$assignmentId')({
  component: withErrorBoundary(AssignmentDetailsPage, {
    fallback: SentryErrorPage,
    beforeCapture: (scope) => scope.setTag('route', Route.fullPath),
  }),
})
